const commentLike = () => {

    // Like and Dislike Comment
    document.querySelectorAll('.interaction__like, .interaction__dislike').forEach(item => {

        let dislikeDone = false,
            likeDone = false;

        item.addEventListener('click', e => {
            e.preventDefault();

            // Get Data
            var comment_id = item.getAttribute('data-comment-id');
            var nonce = item.getAttribute('data-nonce');
            var dislike = item.classList.contains('interaction__dislike');

            if( ( !dislikeDone && dislike)
            ||   !likeDone && !dislike ) {

                var comment_likes = 1;

                // Save Likes
                let xhttp = new XMLHttpRequest();

                // Response
                xhttp.onreadystatechange = function() {
                    if (this.readyState == 4 && this.status == 200) {
                        item.querySelector("span").textContent = Number(item.querySelector("span").textContent) + 1;
                        item.classList.add("active");

                        if(dislike) {
                            dislikeDone = true;
                        }else{
                            likeDone = true;
                        }
                    }
                };

                // action
                xhttp.open("POST", pokaa.ajaxurl, true);
                xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                xhttp.send("action=save_element_likes&element_id=" + comment_id + "&element_likes="
                    + comment_likes + "&is_comment=true&dislike=" + dislike + "&nonce=" + nonce);

            }
        })
    });
}

export default commentLike;